import React from "react";
import { useCart } from "../context/CartContext";
import CartItem from "../components/CartItem";
import { Link } from "react-router-dom"; // ✅ for navigation

const Cart = () => {
  const { cart } = useCart();

  const total = cart.reduce(
    (sum, item) => sum + item.price * (item.quantity || 1),
    0
  );

  return (
    <div style={{ padding: "20px" }}>
      <h2>Your Shopping Cart</h2>

      {cart.length === 0 ? (
        <p>Your cart is empty. Start shopping now!</p>
      ) : (
        <>
          <div style={{ marginTop: "20px" }}>
            {cart.map((item) => (
              <CartItem key={item.id} item={item} />
            ))}
          </div>

          {/* Cart Total */}
          <div
            style={{
              marginTop: "30px",
              padding: "15px",
              borderTop: "2px solid #ddd",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            <span>Total:</span>
            <span>₹{total.toFixed(2)}</span>
          </div>

          {/* ✅ Checkout Button */}
          <div style={{ textAlign: "right", marginTop: "20px" }}>
            <Link to="/checkout">
              <button
                style={{
                  padding: "10px 20px",
                  background: "#007bff",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                Proceed to Checkout
              </button>
            </Link>
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;
